<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'ContactUs',

    metaInfo: { title: 'Pro Features' },

    extends: View,

    mixins: [
      LoadSections(['pro-features']),
    ],

    props: {
      id: {
        type: String,
        default: 'contactus',
      },
    },
  }
</script>
